module.exports = __webpack_public_path__ + "assets/img/d4270081e285f5d33014453fb693b7e5.png";